/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_ExportInputs */

const vi_customer_debt_export = /** @type {(inputs: Customer_Debt_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel`)
};

/**

* @param {Customer_Debt_ExportInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_export = /** @type {((inputs?: Customer_Debt_ExportInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_ExportInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_export(inputs)
});